export const ParagonColors = {
  canvasDark: '#222222',
  canvasLight: '#F4F4F4',
  background: '#2D2D2D',
  paragold: '#F4D367',
  paragoldContrast: '#F2C84E',
  green: '#4D9378',
  orange: '#D5922D',
  red: '#D85323',
  purple: '#9A559C',
  blue: '#657FF4',
};

export const G2Colors = {
  black: {
    rich: '#020202',
    eerie: '#1e1e1e',
    granite: '#606060',
  },
  orange: {
    lighter: '#ff8339',
    g2Orange: '#fa780a',
    darker: '#c54900',
  },
  blue: {
    alternateLight: '#5c91c6',
    alternateDark: '#718ead',
    lighter: '#424c68',
    gunmetal: '#282c3f',
  },
  grey: {
    platinum: '#e3e4db',
    darker: '#b5b5a9',
  },
  white: '#ffffff',
};
